export const FrLocale = {
    page: {
        txtTitle: 'SHIRITORI | Apprenez le vocabulaire japonais en ligne avec le jeu amusant しらとり',
    },
    common: {
        txtLogoAlt: 'Train Shiritori',
    },
    header: {
        txtLeave: 'QUITTER LA PARTIE',
    },
    dialog: {
        leave: {
            txtTitle: 'Quitter cette partie ?',
            btnStay: 'RESTER DANS LA PARTIE',
            btnLeave: 'QUITTER ET ABANDONNER',
        },
    },
    home: {
        btnNewGame: 'NOUVELLE PARTIE',
        btnMainMenu: 'MENU PRINCIPAL',
        btnJoinGame: 'REJOINDRE',
        btnReturnToGame: 'RETOUR À LA PARTIE',
    },
    create: {
        headingNamePrompt: 'Comment devons-nous vous appeler ?',
        placeholderName: 'Votre nom',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Votre nom',
        placeholderGameId: 'id de partie',
        btnJoinGame: 'REJOINDRE',
    },
    configure: {
        header: 'PARAMÈTRES DE LA PARTIE',
        labelExpectedPlayers: 'Nombre de joueurs',
        labelBoardSize: 'Taille du plateau',
        labelWordList: 'Liste de mots',
        labelAllowHints: 'Autoriser les indices',
        labelTurnTimer: 'Chrono de tour',
        optionNoTimer: 'Sans chrono',
        optionTimer: 'Chrono',
        unitSeconds: 's',
        btnStartGame: 'DÉMARRER',
        toastCreateError: 'Erreur : impossible de créer cette partie',
        toastTryAgain: 'Erreur : veuillez réessayer plus tard.',
    },
    game: {
        lobby: {
            btnReady: 'Prêt',
            txtShareInvite: 'Partagez ce code avec vos amis !',
            txtPlayer: 'Joueur',
            txtTeam: 'Équipe',
        },
        message: {
            noSuchGame: 'Cette partie n’existe pas',
            txtLoading: 'Chargement...',
            txtCannotJoin: 'Impossible de rejoindre la partie',
        },
        gameplay: {
            board: {
                timeoutTitle: 'TEMPS',
                timeoutSubtitle: 'écoulé',
            },
            wordSearch: {
                multipleMatches: 'PLUSIEURS CORRESPONDANCES TROUVÉES !',
                yourTurn: 'À VOUS DE JOUER',
                placeholder: 'Quel mot jouer ?',
                playAction: 'JOUER',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'Ce mot n’existe pas !',
                toastCantPlay: 'Impossible de jouer ce mot !',
                toastPlayed: 'A joué "{{word}}"',
                toastPlayFailed: 'Oups, impossible de jouer ce mot !',
                validation: {
                    syllableMismatch: 'La syllabe de départ ne correspond pas',
                    missingLastWord: 'Le dernier tour n’a pas de mot',
                    wordNotInList: 'Le mot ne fait pas partie de la liste',
                }
            },
            spectate: {
                waitingOn: 'En attente de {{player}}',
                timeLeft: 'Temps restant : {{seconds}}s',
            },
            endGame: {
                header: 'PARTIE TERMINÉE',
                viewResults: 'VOIR LES RÉSULTATS',
                statsTotalTime: 'Durée totale',
                statsSquaresFilled: 'Cases remplies',
                statsLongestWord: 'Mot le plus long',
                share: 'Partager',
                sharing: 'Partage en cours...',
                ariaCloseLabel: 'Fermer la fenêtre de fin de partie',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Comment jouer',
        linkPrivacyPolicy: 'Politique de confidentialité',
        txtAllRightsReserved: 'Tous droits réservés.',
    },
    howToPlay: {
        title: 'Comment jouer à Shiritori しりとり (shiritori)',
        btnPlayNow: 'Jouer maintenant !',
        btnReturnToGame: 'Retour à la partie :',
        description1: 'b|Shiritori| est notre version en ligne et multijoueur du jeu japonais de chaîne de mots しりとり. Construisez un plateau illustré tout en pratiquant le vocabulaire avec des amis ou en solo.',
        description2: 'Créez ou rejoignez une partie, choisissez la taille du plateau, le set d’images et la liste de mots, puis remplissez la grille avec des mots valides avant qu’un joueur ne fasse une erreur.',
        gameSetup: {
            title: 'Créer ou rejoindre une partie',
            p1: 'Commencez en solo ou invitez jusqu’à 9 amis (10 joueurs au total) avec un lien partageable ou un code de partie.',
            p2: 'Choisissez vos options : taille du plateau (3x3, 5x5, 7x7), motif/couleur d’arrière-plan, set d’images et liste de mots à étudier.',
            p3: 'Vos amis ouvrent le lien, choisissent un pseudo et apparaissent dans le lobby ; la partie commence quand le nombre attendu de joueurs est atteint.',
            p4: 'Les retardataires peuvent toujours regarder une partie en cours en mode observation.',
        },
        objective: {
            title: 'Objectif',
            p1: 'Chaînez les mots pour que chaque nouveau mot commence par la dernière syllabe du précédent, remplissez le plateau et ne terminez jamais un mot par ん.',
        },
        wordRules: {
            title: 'Mots valides',
            p1: 'Saisissez en kana ou en romaji ; le romaji est converti en hiragana côté client avant vérification.',
            p2: 'Les mots doivent exister dans la liste choisie (100/1000 mots fréquents, nourriture, sports, etc.) et leur sens s’affiche après votre coup.',
            p3: 'Les mots déjà utilisés sont bloqués. Si les homophones sont autorisés, vous pouvez choisir une variante non utilisée avec la bonne image.',
            li1: 'Commence par la syllabe demandée au tour précédent',
            li2: 'Ne se termine pas par ん (n)',
            li3: 'Figure dans la liste choisie',
            li4: 'N’a pas déjà été joué dans cette partie',
            li5: 'Utilise un homophone/une image autorisé si cette règle est activée',
            p4: 'Chaque coup valide place son image sur le plateau dans l’ordre, en remplissant de gauche à droite puis de haut en bas. e|Exemple:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Tours et timing',
            p1: 'Les tours passent d’un joueur à l’autre ; quand c’est votre tour, vous avez jusqu’à 10 secondes à partir du moment où il apparaît.',
            p2: 'Shiritori attend que le joueur suivant soit actif (navigateur au premier plan) avant de lancer son chrono, ce qui empêche de le contourner en redémarrant ou rechargeant.',
            p3: 'Entrez votre mot, suivez la validation en direct et validez avant la limite ; une soumission invalide ou tardive termine immédiatement la partie.',
        },
        boardFlow: {
            title: 'Plateau, déroulement et fin',
            p1: 'Le plateau affiche chaque mot joué avec son image, le nom du joueur et le numéro du tour, avec des flèches pour suivre l’ordre dans la grille.',
            p2: 'Quand c’est le tour d’un autre joueur, vous voyez quand même la syllabe de départ requise et le compte à rebours.',
            p3: 'Si toutes les cases sont remplies avec des mots valides, la partie se termine avec succès et affiche le plateau complet à partager.',
            p4: 'Si aucun coup valide n’est soumis avant la fin du temps, la partie se termine avec un résumé indiquant qui a dépassé le temps ou joué un mot invalide.',
        },
        summary: {
            title: 'Résumé',
            p1: 'Shiritori rend shiritori rapide et visuel : manches courtes, règles claires et repères visuels aident tout le monde à garder la chaîne vivante.',
            p2: 'Partagez un lien, remplissez le plateau et voyez jusqu’où votre chaîne de mots peut aller.',
        }
    },
    bugsAndFeatures: {
        title: 'Signalement de bugs et nouvelles fonctionnalités',
        p1: 'Nous avons créé ce jeu comme une autre façon de jouer au classique k|しりとり.| En tant qu’équipe passionnée de jeux, nous cherchons toujours à l’améliorer pour le rendre plus agréable.',
        cta: {
            l1: 'D’ailleurs, nous serions ravis si vous pouviez nous aider en ',
            a: 'partageant notre jeu avec vos amis',
            l2: ' sur les réseaux sociaux !'
        },
        p2: 'Si vous rencontrez des bugs ou avez des idées de nouvelles fonctionnalités, dites-le-nous !',
        bugs: {
            title: 'Bugs',
            p1: 'Merci de signaler tout comportement étrange, erreur ou bug directement sur notre a|https://github.com/indexinteractive/|dépôt_public_GitHub| . N’hésitez pas à ajouter un maximum de détails, notamment les étapes de reproduction.'
        },
        features: {
            title: 'Nouvelles fonctionnalités',
            p1: 'Si vous avez des suggestions de nouvelles fonctionnalités, d’améliorations ou d’idées pour le jeu, créez une nouvelle discussion sur notre page a|https://github.com/indexinteractive/|GitHub_Discussions| .'
        }
    },
    share: {
        title: 'Shiritori | Apprenez le vocabulaire japonais en ligne avec le jeu amusant しらとり - SHIRITORI',
        text: 'Jouez à Shiritori en ligne avec vos amis ou des joueurs aléatoires. Aucune inscription requise !',
    }
};
